import { render, staticRenderFns } from "./notificationAdd.vue?vue&type=template&id=0a21255f"
import script from "./notificationAdd.vue?vue&type=script&lang=js"
export * from "./notificationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports